import React, {Component} from "react"
import PropTypes from "prop-types"

import {Input} from "@irati/ui/src/FormItem"
import Validation from "@irati/utils/validation"
import id from "@irati/utils/id"
import {injectIntl} from "@irati/utils/lang"

const MIN_TITLE_LENGTH = 3
const MAX_TITLE_LENGTH = 80

export const schema = (intl) => Validation.string(intl.formatMessage({id: "platform.defaultValidation.required"}))
  .min(MIN_TITLE_LENGTH, intl.formatMessage({id: "platform.defaultValidation.minLength"}, {count: MIN_TITLE_LENGTH}))
  .max(MAX_TITLE_LENGTH, intl.formatMessage({id: "platform.defaultValidation.maxLength"}, {count: MAX_TITLE_LENGTH}))

const PROPERTY = "title"

class Title extends Component {
  static propTypes = {
    poll: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    intl: PropTypes.object.isRequired,
    validation: PropTypes.object,
    label: PropTypes.string,
    placeholder: PropTypes.string
  }

  static defaultProps = {
    validation: null,
    label: "recognition.fields.poll.title.label",
    placeholder: "recognition.fields.poll.title.placeholder",
    id: "poll"
  }

  static getDerivedStateFromProps(props, prevState) {
    const {intl} = props
    return {
      validation: props.validation || prevState.validtion || schema(intl)
    }
  }

  state = {}

  handleChange = (value) => {
    const {poll, onChange} = this.props

    onChange(poll, PROPERTY, value)
  }

  render() {
    const {poll, intl, ...props} = this.props
    const {validation} = this.state

    return (
      <Input
        {...props}
        validation={validation}
        onChange={this.handleChange}
        name={id(PROPERTY, this.props)}
        id={id(PROPERTY, this.props)}
        value={poll[PROPERTY]} />
    )
  }
}

export default injectIntl(Title)
